import { getHumanReadableModelName } from "./getHumanReadableModelName.js";
function getHumanReadablePath(args) {
  return args.path.map((element) => {
    if (element.label) {
      return element.label;
    } else if (element.model) {
      return getHumanReadableModelName({
        model: element.model,
        name: element.name
      });
    } else {
      return element.name;
    }
  }).join(" → ");
}
export {
  getHumanReadablePath
};
//# sourceMappingURL=getHumanReadablePath.js.map
